//import { useAxiosLoader } from '../../../utils/axiosInstance';
import { useEffect, useState } from 'react';
import './styles.scss';

const Loading = ({ force = false }: any) => {
  // const [loading] = useAxiosLoader();
  const loading = false;
  const [mounted, setMounted] = useState(force);

  useEffect(() => {
    setMounted(true);
    return () => setMounted(false); // use effect cleanup to set flag false, if unmounted
  }, []);

  if (mounted && loading) {
    return (
      <div className={force || loading ? 'parentDisable' : ''} data-width="100%">
        <div className="overlay-box loading">{/*<div className="loader" />*/}</div>
      </div>
    );
  } else return null;
};

export default Loading;
